import React from 'react';
import Forms from '../../../../../components/molecules/forms';
import Button from '../../../../../components/molecules/buttons';
import useLandingHeader from './hooks';

interface Props {
    isCoffee: boolean;
    searchValue:string;
    setSearchValue: React.Dispatch<string>;
}

function LandingHeader(props : Props) {
  const { isCoffee, searchValue, setSearchValue } = props;
  const {
    navigateToAdd, currentCategory, setCurrentCategory, categoryListLoading, categoryList,
    navigateToModelConfig,
  } = useLandingHeader(isCoffee);
  return (
    <div>
      <div className="row mb-4">
        <div className="col-xl-2 col-lg-3 col-md-4 col-12 mb-4 mb-md-0">
          <Button.Default
            id="modelConfiguration"
            type="button"
            label="Model Configuration"
            onClick={navigateToModelConfig}
            outline
            style={{ borderColor: '#E6E6E6', color: 'grey' }}
          />
        </div>
        <div className="col-xl-5 offset-xl-5 col-lg-6 offset-lg-3 col-md-8 offset-0 col-12">
          <div className="row">
            <div className="col-sm-6 mb-4 mb-sm-0">
              <Forms.ReactSelect.Default
                id="category"
                placeholder="Select Category"
                isSearchable={false}
                options={categoryList}
                disabled={categoryListLoading}
                value={currentCategory}
                onChange={(e) => {
                  if (e) setCurrentCategory(e);
                }}
              />
            </div>
            <div className="col-sm-6">
              <Button.Default
                id="addRoute"
                type="button"
                label={`Add ${isCoffee ? 'Coffee' : 'Vending'} Machine`}
                onClick={navigateToAdd}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 mb-4">
        <Forms.Search
          placeholder="Search"
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
        />
      </div>
    </div>
  );
}

export default React.memo(LandingHeader);
